module.exports = __webpack_public_path__ + "img/eco-responsible-printing.4e1ddc1d.png";